module.exports = __webpack_public_path__ + "static/media/bn.29666430.jpg";